export default __webpack_public_path__ + "static/media/lenze_918_2.c65d3dfa.jpg";